import http from '../utils/fetch';
export default {
  getReportFormData (data) {
    return http({
      url: '/api/swyl/v1/jxsReportForm/getReportFormData',
      method: 'post',
      data
    });
  },
  getJxsGap (data) {
    return http({
      url: '/api/swyl/v1/jxsReportForm/getJxsGap',
      method: 'post',
      data
    });
  },
  // 关差记录表
  getGapByUserCodeAndType (data) {
    return http({
      url: '/api/swyl/v1/boardJxsGap/getGapByUserCodeAndType',
      method: 'post',
      data
    });
  },
  // 提交关差
  getOpenJxsGap (data) {
    return http({
      url: '/api/swyl/v1/boardJxsGap/openJxsGap',
      method: 'post',
      data
    });
  },
  // 关差详情
  getJxsGapById (params) {
    return http({
      url: '/api/swyl/v1/boardJxsGap/getJxsGapById',
      method: 'post',
      params
    });
  },
  // 关差审批
  getApprovalGap (data) {
    return http({
      url: '/api/swyl/v1/boardJxsGap/approvalGap',
      method: 'post',
      data
    });
  },
  // 反馈提交
  getJxsProblemProblem (data) {
    return http({
      url: '/api/swyl/v1/boardJxsGap/jxsProblemProblem',
      method: 'post',
      data
    });
  },
  // 反馈审批选人
  getJxsProblemPush (data) {
    return http({
      url: '/api/swyl/v1/boardJxsGap/jxsProblemPush',
      method: 'post',
      data
    });
  },
  // 反馈审批回复
  getJxsProblemHuifu (data) {
    return http({
      url: '/api/swyl/v1/boardJxsGap/jxsProblemHuifu',
      method: 'post',
      data
    });
  },
  // 分数获取
  getDistribution (data) {
    return http({
      url: '/api/swyl/v1/jxsAbilityDistribution/getDistribution',
      method: 'post',
      data
    });
  },
  // 分数保存
  saveAndUpdate (data) {
    return http({
      url: '/api/swyl/v1/jxsAbilityDistribution/saveAndUpdate',
      method: 'post',
      data
    });
  },
  // 获取地图数据
  getUserMapData (params) {
    return http({
      url: '/api/swyl/v1/board/userMapAndScore/getUserMapData',
      method: 'get',
      params
    });
  },
  // 获取能力诊断数据
  getUserSalesAbility (params) {
    return http({
      url: '/api/swyl/v1/board/userMapAndScore/getUserSalesAbility',
      method: 'get',
      params
    });
  },
  // 获取能力诊断数据
  getUserSalesAbilityPage (params) {
    return http({
      url: '/api/swyl/v1/board/userMapAndScore/getUserSalesAbilityPage',
      method: 'get',
      params
    });
  },

  // 根据当前省市编码获取数据
  getMapAreaData (params) {
    return http({
      url: '/api/swyl/v1/board/userMapAndScore/getMapAreaData',
      method: 'get',
      params
    });
  },
  // 获取地图下钻数据
  selectAgentDataPage (params) {
    return http({
      url: '/api/swyl/v1/board/bscXsptQyuser/selectAgentDataPage',
      method: 'get',
      params
    });
  },

  // 获取区域列表数据
  selectPage (params) {
    return http({
      url: '/api/swyl/v1/sunyicaozuobiao/rateSunyicaozuobiaoArea/selectPage',
      method: 'post',
      params
    });
  },
  // 新增区域接口
  saveInsert (params) {
    return http({
      url: '/api/swyl/v1/sunyicaozuobiao/rateSunyicaozuobiaoArea/insert',
      method: 'post',
      params
    });
  },
  // 修改区域接口
  getUpdateById (params) {
    return http({
      url: '/api/swyl/v1/sunyicaozuobiao/rateSunyicaozuobiaoArea/updateById',
      method: 'post',
      params
    });
  },
  // 查询区域费率
  getSelectByAreaCode (params) {
    return http({
      url: '/api/swyl/v1/sunyicaozuobiao/rateSunyicaozuobiaoArea/selectByAreaCode',
      method: 'post',
      params
    });
  },



  // 创建网络诊断
  createUserSalesAbility (params) {
    return http({
      url: '/api/swyl/v1/board/userMapAndScore/createUserSalesAbility',
      method: 'get',
      params
    });
  },

  // 执行采购单审批
  cgSucess (params) {
    return http({
      url: '/api/swyl/v1/dingd/bsc/OrderCg/cgSucess',
      method: 'post',
      params
    });
  },


}
